import React, { useEffect, useState } from "react";
import { Chart, Title, CommonSeriesSettings, Series, ArgumentAxis, ValueAxis, Format, Label, Tooltip, Export, Crosshair, TickInterval, ZoomAndPan, Legend } from "devextreme-react/chart";

export default function FinancialChart(props) {
  const [visualStartTime, setVisualStartTime] = useState(() => {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1); // Subtract 1 day
    return yesterday;
  });
  const [visualEndTime, setVisualEndTime] = useState(new Date());
  const [currency, setCurrency] = useState({ symbol: "€" });

  useEffect(() => {
    if (props.currency) {
      setCurrency(props.currency);
    }
  }, [props.currency]);

  useEffect(() => {
    if (props.financialChartData && props.financialChartData.length > 0) {
      const visibleData = props.financialChartData.filter((x) => x.isVisible);
      if (visibleData.length > 0) {
        const dates = visibleData.map((x) => new Date(x.date));
        const minDate = new Date(Math.min(...dates));
        const maxDate = new Date(Math.max(...dates));

        const paddedMin = new Date(minDate.getTime() - 1 * 60 * 1000); // minus 1 minute
        const paddedMax = new Date(maxDate.getTime() + 1 * 60 * 1000); // plus 1 minute

        setVisualStartTime(paddedMin);
        setVisualEndTime(paddedMax);
      }
    } else if (props.from && props.to) {
      setVisualStartTime(new Date(props.from.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3")));
      setVisualEndTime(new Date(props.to.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3")));
    }
  }, [props.financialChartData, props.from, props.to]);

  function customizeAnnotation(pointinfo) {
    let color = pointinfo.data.color;
    return {
      color: color,
    };
  }

  function customizeTooltip(pointinfo) {
    let seriesName = pointinfo.seriesName;
    let htmlText = "";
    htmlText += '<b style="text-style: underline">' + seriesName + "</b><br/>";
    // if(seriesName === 'Total'){
    let imgUrl = "";
    if (pointinfo.point.data !== null) {
      if (pointinfo.point.data.isProfit === pointinfo.point.data.isNegative) {
        imgUrl = process.env.PUBLIC_URL + "/images/arrowdown.png";
      } else {
        imgUrl = process.env.PUBLIC_URL + "/images/greenarrow.png";
      }
      let valueTextConverted = pointinfo.valueText.replace(",", "");
      let priceConverted = pointinfo.point.data.price;
      htmlText +=
        '<span><img style="width: 15px, height: 15px" src=' +
        imgUrl +
        ' alt="Taplr Logo"></img> ' +
        currency.symbol +
        parseFloat(valueTextConverted).toLocaleString("nl-BE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
        "</span> <br/>";
      if (seriesName === "Total") {
        htmlText += "<small>" + pointinfo.point.data.originalMeasurement + "</small>";
      }
      htmlText +=
        "<small>" +
        (pointinfo.point.data.thismeasurement !== undefined ? pointinfo.point.data.thismeasurement : "") +
        " (" +
        (pointinfo.point.data.isProfit === pointinfo.point.data.isNegative ? " - " : " + ") +
        currency.symbol +
        priceConverted.toLocaleString("nl-BE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
        ")</small>";
    }
    return {
      html: htmlText,
    };
  }
  function legendClickHandler(e) {
    const series = e.target;
    if (series.isVisible()) {
      series.hide();
    } else {
      series.show();
    }
  }
  function customizePoint(e) {
    let color = e.data.color;

    return {
      color: color,
      size: 6,
    };
  }
  function customizeSeriesPoint(e) {
    return {
      visible: false,
    };
  }

  function customizeCrosshairLabel(e) {
    if (typeof e.value === "number") {
      return currency.symbol + e.point.originalValue.toFixed(2).replace(".", ",");
    } else {
      return new Date(e.point.data.date).toTimeString().split(" ")[0];
    }
  }

  function customizeYAxisText(e) {
    return currency.symbol + e.value.toFixed(2).replace(".", ",");
  }

  return (
    <div style={{ height: "100%", width: "100%" }}>
      {props.financialChartData !== null && props.projectDetailNames.length > 0 ? (
        <Chart
          id="chart"
          style={{ width: "100%" }}
          dataSource={props.financialChartData.filter((x) => x.isVisible)}
          onLegendClick={legendClickHandler}
          customizePoint={customizePoint}
          customizeAnnotation={customizeAnnotation}
        >
          <Tooltip enabled={true} customizeTooltip={customizeTooltip}>
            <Format type="fixedPoint" precision={2} />
          </Tooltip>
          <Title text="Financial overview" subtitle={props.project ? props.project.projectName : ""} />
          <CommonSeriesSettings argumentField="date" type="line" />
          <Format type="fixedPoint" precision={2} />
          {props.projectDetailNames.map((x) => (
            <Series
              valueField={x.id + "_" + x.name + "_price"}
              name={x.registrationPoint ? x.name + " - " + x.registrationPoint : x.name}
              color={x.color}
              customizePoint={customizeSeriesPoint}
              key={x.name}
            >
              {/* <Label visible={true} >
                            <Connector visible={true} />
                        </Label> */}
            </Series>
          ))}
          <ArgumentAxis
            visualRange={{
              startValue: visualStartTime.toISOString(),
              endValue: visualEndTime.toISOString(),
            }}
            argumentType="datetime"
          />
          {/* <ValueAxis
                        visualRange={{
                            startValue: visualStartTime.toISOString(),
                            endValue: visualEndTime.toISOString()
                        }}
                        position="right"
                    >
                        <TickInterval hours={1}></TickInterval>
                    </ValueAxis> */}
          <ValueAxis
            name="amount"
            position="right"
            // tickInterval={1}
            showZero={true}
          >
            <Label customizeText={customizeYAxisText} />
          </ValueAxis>
          <Export enabled={true} />

          <ZoomAndPan panKey="shift" argumentAxis="both" valueAxis="none" allowMouseWheel={true} dragToZoom="true" />
          <Crosshair enabled={true}>
            <Label visible={true} customizeText={customizeCrosshairLabel} />
          </Crosshair>
          {/* <Legend verticalAlignment="bottom" horizontalAlignment="center" /> */}
        </Chart>
      ) : (
        ""
      )}
    </div>
  );
}
